"use client";
import { useReportWebVitals } from "next/web-vitals";
import { usePathname } from "next/navigation";
import { pushEvent } from "@/lib/analytics/gtm";
import { analyticsEvents } from "@/lib/analytics/events";

export function WebVitalsTracker() {
  const pathname = usePathname();
  useReportWebVitals((metric) => {
    pushEvent(analyticsEvents.web_vital, {
      name: metric.name,
      value: metric.value,
      rating: (metric as { rating?: string }).rating,
      id: metric.id,
      path: pathname ?? location.pathname,
    });
  });
  return null;
}
